// import { GlobalReactLooselyLazyProfiler } from "react-loosely-lazy";
import {
    unstable_scheduleCallback as scheduleCallback,
    unstable_IdlePriority as idlePriority
} from "scheduler";

import getMeta from "@atlassian/wac-get-meta";
import { retrieveAndSetPageLoadTrace } from "@atlassian/wac-retrieve-and-set-page-load-trace";
import { startLighthouseObserver } from "@atlassian/wac-ufo-additional-payload";
import { configure as configureBundleEvalTimings } from "@atlassian/wac-ufo-bundle-eval-timing";
import { sinkErrorHandler } from "@atlassian/wac-ufo-global-error-handler";
import { setupHiddenTimingCapture } from "@atlassian/wac-ufo-hidden-timing";
import {
    // ModuleLoadingProfiler,
    type InteractionMetrics,
    addErrorToAll,
    sinkInteractionHandler
} from "@atlassian/wac-ufo-interaction-metrics";
import {
    configure as configureResourceTimings,
    startResourceTimingBuffer
} from "@atlassian/wac-ufo-resource-timing";

// import { configure as configureSsrTiming } from "@atlassian/wac-ufo-ssr";
import { bundleEvalTimingsConfig } from "./common/utils/bundle-eval-config";
import { resourceTimingsConfig } from "./common/utils/resource-config";
let initialized = false;

export default function init() {
    if (initialized) return;

    retrieveAndSetPageLoadTrace(getMeta);

    setupHiddenTimingCapture();
    startLighthouseObserver();

    configureResourceTimings(resourceTimingsConfig);
    startResourceTimingBuffer();

    configureBundleEvalTimings(bundleEvalTimingsConfig);

    // REMOVED: Jira specifics
    // configureSsrTiming(jiraSsrConfig);

    // REMOVED: Waiting react-loosely-lazy new release
    // GlobalReactLooselyLazyProfiler.current = ModuleLoadingProfiler;
    sinkErrorHandler(addErrorToAll);
    initialized = true;

    Promise.all([
        import(
            /* webpackChunkName: "AWC" */ "@atlassian/wac-analytics-web-client-async"
        ),
        import(
            /* webpackChunkName: "create-payloads" */ "@atlassian/wac-ufo-create-payload"
        )
    ]).then(([awc, payloadPackage]) => {
        awc.getAnalyticsWebClientPromise().then((client) => {
            const instance = client.getInstance();
            sinkInteractionHandler(
                (interactionId: string, interaction: InteractionMetrics) => {
                    scheduleCallback(idlePriority, () => {
                        const payloads = payloadPackage.createPayloads(
                            interactionId,
                            interaction
                        );
                        payloads?.forEach((payload) => {
                            instance.sendOperationalEvent(payload);
                        });
                    });
                }
            );
        });
    });
}
